import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { CommentCSSProperties } from './types';
import TrustedHtml from '@/components/TrustedHtml';
import { Maybe } from '@/types';
function Comment(t0) {
  const $ = _c(6);
  const {
    comment,
    style,
    className
  } = t0;
  if (!comment) {
    return null;
  }
  let t1;
  if ($[0] !== className) {
    t1 = classNames("listComment", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== comment || $[3] !== style || $[4] !== t1) {
    t2 = <TrustedHtml value={comment} as="div" style={style} className={t1} />;
    $[2] = comment;
    $[3] = style;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
export default Comment;